import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }

import { computed, getCurrentInstance, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import BasicSpinner from '@/components/BasicSpinner'
import { injectPageLoading } from '@/composables/usePageLoading'


export default {
  __name: 'NeueLoading',
  props: ['loading'],
  setup(__props) {

const props = __props

const page = injectPageLoading()
const root = ref(null)
const onScreen = ref(true)
const loadedOnce = ref(false)

watch(
  () => props.loading,
  (loading, wasLoading) => {
    if (wasLoading && !loading) loadedOnce.value = true
  }
)

const instance = getCurrentInstance()
const shownRecord = computed(() => {
  const route = instance?.proxy?.$route
  if (!route) return null
  const record = Object.entries(route.params).filter(([key]) => key !== 'tab')
  return `${route.matched.at(-1)?.path}:${JSON.stringify(record)}`
})
watch(shownRecord, () => (loadedOnce.value = false))

const firstLoadForPage = computed(() => !!page && !loadedOnce.value)
const showsOwnOverlay = computed(() => !!props.loading && !firstLoadForPage.value)

page?.track(computed(() => firstLoadForPage.value && !!props.loading && onScreen.value))

let observer
onMounted(() => {
  if (!page || typeof IntersectionObserver === 'undefined') return
  observer = new IntersectionObserver(([entry]) => (onScreen.value = entry.isIntersecting), {
    rootMargin: '100000px'
  })
  observer.observe(root.value)
})
onBeforeUnmount(() => observer?.disconnect())

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "relative"
  }, [
    _createElementVNode("div", {
      "data-local-loading": "",
      class: _normalizeClass(["absolute h-full w-full backdrop-blur-sm z-20 transition-opacity duration-100", showsOwnOverlay.value ? 'opacity-100 cursor-wait' : 'opacity-0 pointer-events-none'])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BasicSpinner), { size: "medium" })
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

}